<template>
  <div ref="footer" v-if="detail" v-html="detail.platformCopyright"></div>
	<!--<div ref="footer">
		<div style="font-size:12px;  padding: 36px 0; text-align: center; color: #AEB2B9; background-color: #2D3B50; line-height: 22px;">
			<div class="yq-links" style="display: block; font-size:12px; text-align:center;  width:1200px; margin:0 auto 32px;">
				<a style="color:#AEB2B9; padding:0 25px; height:14px; border-right:1px solid #A7ACB4;" href="javascript:;" target="_blank">关于我们</a>
				<a style="color:#AEB2B9; padding:0 25px; height:14px; border-right:1px solid #A7ACB4;" href="javascript:;" target="_blank">联系我们</a>
				<a style="color:#AEB2B9; padding:0 25px; height:14px; border-right:1px solid #A7ACB4;" href="javascript:;" target="_blank">服务协议和隐私政策</a>
				<a style="color:#AEB2B9; padding:0 25px; height:14px;" href="javascript:;" target="_blank">帮助与反馈</a>
			</div>
			<div style="text-align: center; margin-bottom:24px;">
				<img style="height:41px;" src=".././static/img/index/foot-img.png" alt="">
			</div>
			<div>Copyright © 2021 广州云奕通科技有限公司 All Rights Reserved<br>粤ICP备2021034068号</div>
		</div>
	</div>-->
	<!-- <div ref="footer" v-if="detail" v-html="detail.platformCopyright"></div> -->
	<!-- <div class="footer" style="background:#00142F; color:#fff; ">
		<div class="w1200" style="width:1200px; margin:0 auto;"><div class="foot-ctn clearfix" style="padding:70px 0; overflow:hidden"><div class="about" style="float:left; width:448px;"><h3 style="font-size:18px; margin-bottom:30px; font-weight:bold;">关于我们</h3><p style="font-size:14px; line-height:24px; margin-bottom:14px;color:rgba(255,255,255,.55);">主管单位：江西省教育电视台</p><p style="font-size:14px; line-height:24px; margin-bottom:14px;color:rgba(255,255,255,.55);">承办单位：江西教育电视台高等教育资源建设中心</p><p style="font-size:14px; line-height:24px;color:rgba(255,255,255,.55);">技术支持：江西赣教云科技有限公司</p></div><div class="friend-link" style="overflow:hidden;"><h3 style="font-size:18px; margin-bottom:30px; font-weight:bold;">友情链接</h3><ul style="display:flex; flex-wrap: wrap;"><li style="font-size:14px; line-height:24px; margin-bottom:14px; width:48%; box-sizing: border-box; margin-right:4%; cursor: pointer; color:rgba(255,255,255,.55);">江西教育电视台</li><li style="font-size:14px; line-height:24px; margin-bottom:14px; width:48%; box-sizing: border-box;cursor: pointer; color:rgba(255,255,255,.55);">国家数字化学习资源中心</li><li style="font-size:14px; line-height:24px; margin-bottom:14px; width:48%; box-sizing: border-box; margin-right:4%; cursor: pointer; color:rgba(255,255,255,.55);">赣教云-江西省中小学线上教学平台</li><li style="font-size:14px; line-height:24px; margin-bottom:14px; width:48%; box-sizing: border-box; cursor: pointer; color:rgba(255,255,255,.55);">中国教育技术协会</li></ul></div></div><div class="copyright" style="border-top:1px solid rgba(255, 255, 255, .21); padding:30px 0; text-align: center;"><p style="font-size:14px; line-height:24px;">粤ICP备<a target="_blank" href="https://beian.miit.gov.cn/" style="color:#fff;">2021034068</a>号</p></div></div>
		</div> -->
</template>

<script>
	export default {
		name: '',
		data() {
			return {
				detail: null
			}
		},
		async created() {
			await this.$onLaunched; //监听加载了APP.vue中的onLaunched的异步后执行
			this.getFooterCode()
		},
		methods: {
			//获取底部代码
			getFooterCode() {
				// function htmlToText(text) {
				// 	// let div = document.createElement('div');
				// 	// div.innerHTML = html
				// 	// return div.textContent;
				// 	//1.首先动态创建一个容器标签元素，如DIV
				// 	var temp = document.createElement("div");
				// 	//2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
				// 	temp.innerHTML = text;
				// 	//3.最后返回这个元素的innerText或者textContent，即得到经过HTML解码的字符串了。
				// 	var output = temp.innerText || temp.textContent;
				// 	temp = null;
				// 	return output
				// }
				this.$axios({
					url: `/jxedu/api/site/bottomCopyright`,
				}).then(res => {
					let detail = res.data
					//detail.platformCopyright = htmlToText(detail.platformCopyright)
					this.detail = detail

					setTimeout(() => {
						this.$store.commit('changeFootHeight', this.$refs.footer.offsetHeight)
					}, 500)
				})
			}

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.footer {
		background: #00142F;
		color: #fff;
		// .foot-ctn{
		// 	padding:70px 0;
		// 	h3{ font-size:18px; margin-bottom:30px; font-weight: bold; }
		// 	.about{
		// 		float:left; width:448px;
		// 		p{
		// 			font-size:14px; line-height:24px; margin-bottom:14px; color:rgba(255,255,255,.55);
		// 			&:last-child{ margin-bottom:0; }
		// 		}
		// 	}
		// 	.friend-link{
		// 		overflow: hidden;
		// 		ul{
		// 			display:flex; flex-wrap: wrap;
		// 			li{
		// 				font-size:14px; line-height:24px; margin-bottom:14px; width:48%; box-sizing: border-box;
		// 				margin-right:4%; cursor: pointer; color:rgba(255,255,255,.55);
		// 				&:nth-child(2n){ margin-right:0; }
		// 				&:hover{ text-decoration: underline; color:#fff; }
		// 			}
		// 			font-size:14px;
		// 			line-height:24px;
		// 		}
		// 	}
		// }

		// .copyright{
		// 	border-top:1px solid rgba(255, 255, 255, .21); padding:30px 0; text-align: center;
		// 	p{
		// 		img{ width:24px; height:24px; vertical-align: top; margin-right:8px;}
		// 		font-size:14px; line-height:24px;
		// 	}
		// }
	}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue